import React from 'react'
import {isEmpty} from 'lodash'
import {useBooleanState} from 'powtoon-commons/hooks'
import {useOnClickOutside} from 'powtoon-commons/hooks'
import {Icon, Text} from '@powtoon/design-system-components'
import {getLanguageName} from 'powtoon-commons/utils/language'
import classNames from 'classnames'
import './CaptionsControl.scss'

export interface CaptionsControlProps {
  locales?: string[],
  setActiveCaptionLocale: (locale: string | null) => void,
  initialCaptionLocale: string
}

const CaptionsControl: React.FC<CaptionsControlProps> = ({locales, setActiveCaptionLocale, initialCaptionLocale}) => {
  const [showMenu, toggleShowMenu,, closeMenu] = useBooleanState(false)
  const [activeLocale, setActiveLocale] = React.useState(initialCaptionLocale)
  const menuRef = React.useRef(null)
  const iconName = `closed-captions${activeLocale ? '-filled' : ''}`

  if (isEmpty(locales)) {
    return null
  }

  const captionList = React.useMemo(() => {
    return locales?.map((locale) => (
      <div styleName="language-option" key={locale} onClick={() => setActiveCaption(locale)}>
        <Text color="invert" fontStyle="medium">{getLanguageName(locale)}</Text>
        {activeLocale === locale && <Icon color="#fff" name="checkmark" />}
      </div>
    ))
  }, [locales, setActiveCaptionLocale, activeLocale])

  const handleTurnOff = React.useCallback(() => {
    setActiveLocale('')
    setActiveCaptionLocale(null)
  }, [setActiveCaptionLocale])

  const setActiveCaption = React.useCallback((locale) => {
    setActiveLocale(locale)
    setActiveCaptionLocale(locale)
  }, [setActiveCaptionLocale, locales])

  useOnClickOutside(menuRef, closeMenu)
  
  return (
    <div styleName="captions-toggle-container" onClick={toggleShowMenu} ref={menuRef}>
      <Icon name={iconName} {...(!activeLocale && {color: '#ffffff'})}/>
      {showMenu && (
        <div styleName="caption-menu">
          <div styleName="menu-header">
            <Text color="invert" fontStyle="medium">Subtitles/CC</Text>
          </div>
          <div styleName={classNames('options-container', {'options-overflow': locales && locales.length > 5})}>
            <div styleName="language-option" onClick={handleTurnOff}>
              <Text color="invert" fontStyle="medium">Off</Text>
              {!activeLocale && <Icon color="#fff" name="checkmark" />}
            </div>
            {captionList}
          </div>
        </div>
      )}
    </div>
  )
}

export default CaptionsControl